// Filter enriched subscriptions down to those in the selected client's history.
// history records carry ids; match each enriched sub by user_subscription_id.
export function historySubs(selectedClient, recentClientSubscriptions) {
    const history = selectedClient && selectedClient.client_subscription_history
    if (!Array.isArray(recentClientSubscriptions)) return []
    // no history field (backend omits it when the client has no history rows):
    // fall back to the full enriched list so the dropdown isn't empty
    if (!Array.isArray(history)) return recentClientSubscriptions
    return recentClientSubscriptions
        .filter(sub => history.find(h => h.id === sub.user_subscription_id))
        .map(sub => {
            const historyItem = history.find(h => h.id === sub.user_subscription_id)
            return Object.assign({}, sub, {
                price: historyItem.price,
                current_percent: historyItem.current_percent,
                current_parent_percent: historyItem.current_parent_percent,
                paid_at: historyItem.paid_at,
                cancelled_at: historyItem.cancelled_at
            })
        })
}
